export const EPMS_API_BASE_URL = [
    { key: "localhost", value: "localhost", baseUrl: "http://localhost:8080" },
    { key: "http://epmsuiqa.devmpsconline.in", value: "http://epmsuiqa.devmpsconline.in", baseUrl: "http://epmsuiqa.devmpsconline.in" },
    { key: "epmsuiqa", value: "http://epmsuiqa.devmpsconline.in", baseUrl: "http://epmsuiqa.devmpsconline.in" },
]

export const EPMS_API_CAPTCHA_URL = [
    { key: "localhost", value: "localhost", baseUrl: "http://localhost:8080/epms/api/v1/admin/otps" },
    { key: "http://epmsuiqa.devmpsconline.in", value: "http://epmsuiqa.devmpsconline.in", baseUrl: "http://epmsuiqa.devmpsconline.in/epms/api/v1/admin/otps" },
    { key: "epmsuiqa", value: "http://epmsuiqa.devmpsconline.in", baseUrl: "http://epmsuiqa.devmpsconline.in/epms/api/v1/admin/otps" },
]